export default function clamp(min: number, value: number, max: number) {
	if (max !== null && max !== undefined) {
		value = Math.min(max, value);
	}
	if (min !== null && min !== undefined) {
		value = Math.max(min, value);
	}
	return value;
}